// extracted by mini-css-extract-plugin
module.exports =  {"link":"_32bbee5fda--link--XUJiq","content":"_32bbee5fda--content--vuQw2"};